import { useState, useEffect } from 'react';
import { BackendLink, SmartProjectCard } from '../../Components';
import './ProjectsSec.css';

const ProjectsSec = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllProjects/`);
                if (!response.ok) {
                    throw new Error('Failed to fetch projects');
                }
                const data = await response.json();
                setProjects(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    return (
        <ul className="all-projects">
            {loading || error || projects.length === 0
                ? Array.from({ length: 6 }).map((_, idx) => (
                    <SmartProjectCard
                        key={idx}
                        loading={loading}
                        error={!!error || projects.length === 0}
                        project={null}
                    />
                ))
                : projects.map(project => (
                    <SmartProjectCard
                        key={project.id}
                        loading={false}
                        error={false}
                        project={project}
                    />
                ))
            }
        </ul>
    );
}

export default ProjectsSec;
